<template>
  <div>
    <ul>
      <li>token_version_id: {{ $route.query.token_version_id }}</li>
      <li>enc_data: {{ $route.query.enc_data }}</li>
      <li>integrityValue: {{ $route.query.integrity_value }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  methods: {
    emitIdentifyResults() {
      const object = {
        encData: this.$route.query.enc_data,
        key: window.opener.document.getElementById("inputKey").value,
        iv: window.opener.document.getElementById("inputIv").value,
      };

      const queryString = Object.keys(object)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`
        )
        .join("&");

      window.opener.location.href = `/signup?${queryString}`;
      window.close();
    },
  },
  created() {
    this.emitIdentifyResults();
  },
};
</script>
